import { Flex } from 'components/common/flex/Flex'
import { ReactComponent as TitleDecoration } from 'components/descriptionSection/assets/title-decoration.svg'
import styles from 'components/descriptionSection/DescriptionSection.module.scss'

export const DescriptionSection = () => {
  return (
    <div className={styles.container}>
      <Flex direction="column" align="center">
        <div className={styles.titleContainer}>
          <h2 className={styles.title}>
            Why We Prioritize
          </h2>
          <TitleDecoration className={styles.titleDecoration} />
        </div>
      </Flex>
    </div>
  )
}
